<template>
  <div>
    <b-form>
      <b-row>
        <b-col md="12">
          <b-form-group
            label="Action"
            label-for="action"
          >
            <v-select
              v-model="reasonID"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="caseReasonOptions"
              :reduce="val => val.value"
              :clearable="false"
              input-id="action"
            />
          </b-form-group>
        </b-col>
        <b-col
          v-if="reasonID > 0"
          cols="12"
        >
          <b-button
            variant="primary"
            type="submit"
            class="addActionBtn"
            @click.prevent="submitStateForm"
          >
            {{ $t('DEBTIA_SUBMIT') }}
          </b-button>
        </b-col>
      </b-row>
    </b-form>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import axios from '@axios'
import {
  BFormGroup,
  BButton,
  BForm,
  BRow,
  BCol,
} from 'bootstrap-vue'

export default {
  components: {
    // BCardCode,
    BForm,
    BRow,
    BCol,
    BFormGroup,
    vSelect,
    BButton,
  },
  props: {
    conditionObject: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      reasonID: 0,
      caseReasonOptions: [],
    }
  },
  created() {
    this.getCaseReasonOptions()
  },
  methods: {
    submitStateForm() {
      const url = '/process/module/add'
      const processID = this.$route.params.id
      const dataObj = {
        process_id: Number(processID),
        module_id: 6,
        module_order: 1,
        reason_id: this.reasonID,
      }
      if (this.conditionObject.moduleID > 0) {
        dataObj.depends_on = this.conditionObject.moduleID
        dataObj.condition = this.conditionObject.type
      }
      axios.post(url, dataObj).then(response => {
        if (response.status === 200) {
          this.reasonID = 0
          const returnObj = {
            parentID: this.conditionObject.parentID,
            depend: dataObj.depends_on,
          }
          returnObj.type = this.conditionObject.type ? this.conditionObject.type : 0
          this.$emit('closeActionModal', returnObj)
        }
      })
    },
    async getCaseReasonOptions() {
      const url = '/get-reason-options'
      await axios.get(url).then(response => {
        if (response.status === 200) {
          this.caseReasonOptions = response.data.data
        }
      })
    },
  },
}
</script>

<style lang="scss">
  @import '@core/scss/vue/libs/vue-select.scss';
  .addActionBtn {
    width: 100%;
  }
</style>
